// extracted by mini-css-extract-plugin
module.exports = {"timeCount":"RookieTask_style_timeCount__15Wen","time":"RookieTask_style_time__33hTQ","text":"RookieTask_style_text__3QhAC"};